import React, { useState } from 'react';
import { CreditCard, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { useLang, tx } from '../i18n/LanguageContext';

export const StripeCheckoutButton = ({ planId, className }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/payments/checkout', { plan_id: planId, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || L('تعذر بدء عملية الدفع، حاول مرة أخرى', 'Could not start checkout, please try again'));
      setBusy(false);
    }
  };

  return (
    <button type="button" data-testid={`stripe-checkout-${planId}`} onClick={start} disabled={busy} className={className}>
      {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <CreditCard className="w-5 h-5" />}
      {busy ? L('جارٍ التحويل للدفع...', 'Redirecting to checkout...') : L('اشترك الآن', 'Subscribe now')}
    </button>
  );
};
